import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useGlobalState } from '../shared/state';
import Spinner from '../components/Spinner';

export const RedirectPage: React.FC = () => {
  const [redirectMap] = useGlobalState('redirectMap');
  const { id: manifestId } = useParams<{ id: string }>();
  useEffect(() => {
    if (manifestId) {
      window.location.href = redirectMap[manifestId];
    }
  }, []);

  return <Spinner />;
};
